const euCollection = {
  collection: {}
}

module.exports = euCollection
